/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Box from '@mui/system/Box';
import Typography from '@mui/material/Typography';
import { PhoneNumberInput } from '@components';

interface PhoneInputStepProps {
  phoneNumber: string;
  onPhoneNumberChange: (value: string | undefined) => void;
  countryCode: string;
  onCountryCodeChange: (country: string) => void;
}

const makeStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    alignItems: 'center',
    width: '100%',
  },
  iconContainer: {
    height: '170px',
    width: '274px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    alignItems: 'center',
    width: '430px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'center',
    textAlign: 'center',
    color: '#1E202C',
    width: '430px',
  },
  title: {
    fontFamily: 'Urbanist',
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: '40px',
    color: '#1E202C',
    width: '428px',
  },
  description: {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#1E202C',
    width: '428px',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '391px',
  },
});

export function PhoneInputStep({
  phoneNumber,
  onPhoneNumberChange,
  countryCode,
  onCountryCodeChange,
}: PhoneInputStepProps) {
  const sx = makeStyles();

  return (
    <Box sx={sx.container}>
      <Box sx={sx.contentContainer}>
        <Box sx={sx.textContainer}>
          <Typography sx={sx.title}>Let's make your account more secure</Typography>
          <Typography sx={sx.description}>
            We will send a code to your phone number to verify your device. This adds an extra layer
            of protection and enables notifications about your finances and milestones in this
            device.
          </Typography>
        </Box>
        <Box sx={sx.inputContainer}>
          <PhoneNumberInput
            value={phoneNumber}
            onChange={onPhoneNumberChange}
            country={countryCode}
            onCountryChange={onCountryCodeChange}
            inputId="phone-input"
            label="Your Phone Number"
            name="phoneNumber"
          />
        </Box>
      </Box>
    </Box>
  );
}
